<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on" class="d-flex align-start">
        <template v-if="code != null">
          <span
            :class="[
              'px-2',
              'py-1',
              'font-weight-bold',
              textColor,
              'text--darken-2',
              'd-flex',
              'align-center',
            ]"
            :style="{
              backgroundColor: backgroundColor,
              borderRadius: '8px',
              maxWidth: 'fit-content',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }"
          >
            <v-icon
              left
              size="18"
              style="font-weight: bold"
              :class="['mr-1', textColor, 'text--darken-2']"
              >{{ icon }}</v-icon
            >
            <span class="text-truncate" style="flex: 1">
              {{ email }}
            </span>
          </span>
        </template>

        <template v-else>
          <span
            class="d-flex align-center justify-start"
            style="display: inline-block; width: fit-content"
          >
            <v-avatar
              v-if="header === 'source_email' || header === 'author'"
              size="20"
              class="mr-1"
            >
              <img :src="getUserAvatar(email)" :alt="verifyUserName" />
            </v-avatar>
            <span class="text-truncate" style="flex: 1">
              {{ email }}
            </span>
          </span>
        </template>
      </span>
    </template>
    <span>
      <b v-if="code != null">{{ tooltipMessage }}</b>

      <template v-else-if="header === 'source_email' || header === 'author'">
        <b>{{ verifyUserName }}</b
        ><br />
        <small>{{ email }}</small>
      </template>

      <template v-else>
        <small>{{ email }}</small>
      </template>
    </span>
  </v-tooltip>
</template>

<script>
import defaultUserPhoto from "@/assets/user-default.png";
import { mapGetters } from "vuex";
import { getMigrationValidationCode } from "@/helpers/variables/migrations";

export default {
  name: "Email",

  props: {
    email: { type: String, default: "" },
    code: { type: String, default: null },
    header: { type: String, default: null },
  },

  data() {
    return {
      user: {},
    };
  },

  methods: {
    getUserAvatar(user_email) {
      const user = this.users.find((u) => u.email === user_email);
      this.user = user;
      return user && user.photo ? user.photo : defaultUserPhoto;
    },
  },

  computed: {
    ...mapGetters(["users"]),
    verifyUserName() {
      return this.user?.name || this.email || "Usuário não encontrado";
    },
    dynamicLabel() {
      const labelKey =
        {
          source_email: "user",
          target_email: "group",
          target_drive_email: "user",
        }[this.header] || "user";

      return this.$t(`migrationLabel.${labelKey}`);
    },
    config() {
      return getMigrationValidationCode()[this.code] || {};
    },
    tooltipMessage() {
      return typeof this.config.tooltipMessage === "function"
        ? this.config.tooltipMessage(this.dynamicLabel)
        : this.config.tooltipMessage;
    },
    icon() {
      return this.config.icon;
    },
    textColor() {
      return this.config.textColor;
    },
    backgroundColor() {
      return this.config.backgroundColor;
    },
  },
};
</script>
